let exportPemKey = async (key) => {
    checkProtocol();
    let exported = await window.crypto.subtle.exportKey('spki', key);
    let exportedAsBase64 = btoa(String.fromCharCode.apply(null, new Uint8Array(exported)));
    let exportedAsPem = `-----BEGIN PUBLIC KEY-----\n${exportedAsBase64}\n-----END PUBLIC KEY-----`;
    return exportedAsPem;
};
let generateKey = async () => {
    checkProtocol();
    let key = await window.crypto.subtle.generateKey({
        name: 'RSA-OAEP',
        modulusLength: 2048,
        publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
        hash: { name: 'SHA-256' }, // can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
    }, true, // whether the key is extractable (i.e. can be used in exportKey)
    ['encrypt', 'decrypt'] // can be any combination of "sign" and "verify"
    );
    return key;
};
let generateKeyPair = async () => {
    let keys = await generateKey();
    let publicKey = await exportPemKey(keys.publicKey);
    let privateKey = keys.privateKey;
    return { publicKey, privateKey };
};
let b642ab = (base64string) => {
    return Uint8Array.from(window.atob(base64string), (c) => c.charCodeAt(0));
};
const checkProtocol = () => {
    const { protocol, hostname } = window.location;
    if (protocol === "https:")
        return true;
    if (["localhost", "127.0.0.1"].includes(hostname))
        return true;
    throw new Error(`Cannot generate keys because your protocol is ${protocol}. Only https: is supported`);
};
export const decryptData = async (privateKey, encrypted) => {
    checkProtocol();
    let decrypted = await window.crypto.subtle.decrypt({
        name: 'RSA-OAEP',
    }, privateKey, b642ab(encrypted));
    decrypted = new TextDecoder().decode(decrypted);
    return decrypted;
};
export default generateKeyPair;
